module.exports = __webpack_public_path__ + "img/card-about-us-section-our-core-values.84b8ca23.png";